export const DisabledReasonTooltipTestIds = {
  CONTAINER: 'disabled-reason-tooltip.container',
  TITLE: 'disabled-reason-tooltip.title',
  REASON: 'disabled-reason-tooltip.reason',
  HINT: 'disabled-reason-tooltip.hint',
};
